import { StyleSheet, Platform } from 'react-native'
import type { Theme } from '../../../theme/getTheme'

export function getAccountMembersDirectoryControlsStyles(theme: Theme) {
  return StyleSheet.create({
    controlsBlock: {
      width: '100%',
      alignSelf: 'stretch',
      marginBottom: theme.spacing.md,
      gap: theme.spacing.sm,
    },
    searchRow: {
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
      borderWidth: 1,
      borderColor: theme.gray[300],
      borderRadius: 8,
      backgroundColor: theme.background.card,
      paddingHorizontal: theme.spacing.sm,
      ...(Platform.OS === 'web' && {
        boxSizing: 'border-box' as never,
      }),
    },
    searchIconWrap: {
      marginRight: theme.spacing.xs,
    },
    searchInput: {
      flex: 1,
      minWidth: 0,
      paddingVertical: theme.spacing.sm,
      fontSize: 15,
      color: theme.gray[900],
      ...(Platform.OS === 'web' && {
        outlineStyle: 'none' as never,
      }),
    },
    filterRow: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: theme.spacing.xs,
    },
    sortRow: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: theme.spacing.xs,
    },
    sortLabel: {
      fontSize: 13,
      fontWeight: '600',
      color: theme.gray[600],
      marginRight: theme.spacing.xs,
    },
    chip: {
      paddingVertical: theme.spacing.xs,
      paddingHorizontal: theme.spacing.sm,
      borderRadius: 8,
      borderWidth: 1,
      borderColor: theme.gray[300],
      backgroundColor: 'transparent',
    },
    chipActive: {
      borderColor: theme.primary,
      backgroundColor: theme.primary + '14',
    },
    chipText: {
      fontSize: 13,
      fontWeight: '600',
      color: theme.gray[700],
    },
    chipTextActive: {
      color: theme.primary,
    },
    chipPressed: {
      opacity: 0.85,
    },
    chipHover: {
      opacity: 0.92,
    },
    chipDisabled: {
      opacity: 0.45,
    },
    resultsSummary: {
      fontSize: 12,
      color: theme.gray[600],
    },
  })
}
